import React from 'react';
import ReceivedAmountList from './ReceivedAmountList';

const ReceivedAmountPage: React.FC = () => {
  return <ReceivedAmountList />;
};

export default ReceivedAmountPage; 